<template>
  <main class="w-full flex-grow p-6">
    <button
      @click="showModalPromotion"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Promo
    </button>

    <div class="w-full lg:w-1/4 pr-0 lg:pr-2">
      <input
        v-model="table.search"
        @keyup="searchSubscriber"
        type="text"
        class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
        placeholder="Search name"
      />
    </div>

    <div class="mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Carousel</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Option</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in promotions"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{
                table.current_page === 1
                  ? index + 1
                  : index + 1 + (table.current_page - 1) * table.per_page
              }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.promotion_name }}
              </span>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  class="w-10 h-10 cursor-pointer"
                  :src="sos.promotion_carousel"
                  alt="23paskal"
                  @click="showModal(sos.promotion_carousel)"
                />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button class="" type="button" @click="detailContent(sos.id)">
                  <span class="font-bold text-app-default">
                    More
                  </span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">
            {{ table.current_page * table.per_page - table.per_page + 1 }}
          </span>
          to
          <span class="font-medium">
            {{ table.current_page * table.per_page }}
          </span>
          of
          <span class="font-medium">{{ table.total }}</span>
          results
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <button
            type="button"
            @click="previewPage"
            :disabled="table.current_page === 1"
            class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div v-if="Math.ceil(table.total / table.per_page) < 5" class="">
            <button
              v-for="pg in Math.ceil(table.total / table.per_page)"
              :key="pg"
              @click="findpage(pg)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === pg
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ pg }}
            </button>
          </div>
          <div v-else class="">
            <button
              @click="findpage(1)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              1
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 2
                    : table.current_page === 2
                    ? 2
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 2
                    : table.current_page - 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{
                table.current_page === 1
                  ? 2
                  : table.current_page === 2
                  ? 2
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 2
                  : table.current_page - 1
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 3
                    : table.current_page === 2
                    ? 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 2
                    : table.current_page
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 3
                  : table.current_page === 2
                  ? 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 2
                  : table.current_page
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 4
                    : table.current_page === 2
                    ? 4
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? Math.ceil(table.total / table.per_page) - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 1
                    : table.current_page + 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 2
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 3
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page > 1 &&
                    table.current_page <
                      Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 4
                  : table.current_page === 2
                  ? 4
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? Math.ceil(table.total / table.per_page) - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 1
                  : table.current_page + 1
              }}
            </button>

            <button
              @click="findpage(Math.ceil(table.total / table.per_page))"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === Math.ceil(table.total / table.per_page)
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ Math.ceil(table.total / table.per_page) }}
            </button>
          </div>

          <!-- <button v-for="pg in Math.ceil(table.total / table.per_page)" :key="pg" @click="findpage(pg)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page === pg ? 'bg-app-default text-white' : 'bg-white text-black']">
            {{ pg }}
          </button> -->
          <button
            type="button"
            @click="nexPage"
            :disabled="
              Math.ceil(table.total / table.per_page) === table.current_page
            "
            class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Next</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>

    <!-- modal create -->
    <div
      v-if="modalpromotion"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 1000px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Add New Promotion</div>
            <div class="">
              <button
                @click.self="showModalPromotion"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="w-full pr-0 lg:pr-2">
              <label class="font-semibold text-black opacity-80"
                >Promo Status</label
              >
              <div class="flex flex-row items-center h-9 mb-5">
                <div
                  class="relative cursor-pointer"
                  @click="create.is_active = !create.is_active"
                >
                  <div
                    class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                    :class="{ 'bg-app-default': create.is_active }"
                  ></div>
                  <div
                    class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                    :class="{ 'translate-x-6': create.is_active }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="w-80">
              <label class="font-semibold text-black opacity-80"
                >Products (1020 px X 1020 px)</label
              >
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.product_images ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewProductPromo"
              >
                <input
                  type="file"
                  accept="image/*"
                  multiple="multiple"
                  @change="previewProductPromo"
                  id="product_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row flex-wrap">
                  <div
                    v-if="avatar.previewFileProduct.length"
                    class="mr-1 relative rounded-lg"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeProductPromotion"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewFileProduct[0]"
                      class="w-80 h-64 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewFileProduct.length === 0"
                    v-cloak
                    @click="chooseSingleFile()"
                    class="w-80 h-80 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.product_images_msg }}
              </div>
            </div>
            <label class="font-semibold text-black opacity-80"
              >Carousel (1200 px X 500 px)</label
            >
            <div class="">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                :class="[
                  errors.carousel_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewCarouselPromo"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewCarouselPromo"
                  id="carousel_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="avatar.previewFileCarousel"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeCarouselPromotion()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewFileCarousel"
                      class="w-full h-96 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewFileCarousel === null"
                    v-cloak
                    @click="chooseFileLocation()"
                    class="w-full h-96 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.carousel_image_msg }}
              </div>
            </div>
            <div class="flex flex-wrap">
              <Select
                :selectItem="selectItem"
                :data="dropDown.dataSelect"
                :open="dropDown.isOpen"
                :selected="dropDown.selected"
                :openSelect="openSelect"
                :search="onSearch"
                :inputSearch="dropDown.inputSearch"
                :id="create.tenant_id"
                :isError="errors.tenant_id"
                :errorMessage="errors.tenant_id_msg"
                :title="dropDown.title"
              />

              <Select
                :selectItem="categorySelectItem"
                :data="categoryDropDown.dataSelect"
                :open="categoryDropDown.isOpen"
                :selected="categoryDropDown.selected"
                :openSelect="categoryOpenSelect"
                :id="create.category_promotion_id"
                :isError="errors.category_promotion_id"
                :errorMessage="errors.category_promotion_id_msg"
                :title="categoryDropDown.title"
              />

              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Promo Name</label
                >
                <input
                  v-model="create.promotion_name"
                  @keyup="promotionNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.promotion_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Promo Description</label
                >
                <!-- <textarea
                  v-model="create.promotion_description"
                  @keyup="promotionDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="create.promotion_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="promotionDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    create?.promotion_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ create?.promotion_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.promotion_description_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Star Promo</label
                >
                <v-date-picker
                  timezone=""
                  v-model="create.promotion_start"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >End Promo</label
                >
                <v-date-picker
                  timezone=""
                  v-model="create.promotion_end"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalPromotion"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <button
                @click="createPromo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalPromotion"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <SuccessNotif />
    <WarningTenant />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import Select from "../../components/Select.vue";
import Modal from "../../components/Modal.vue";
import WarningTenant from "../../components/WarningTenant.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Table",
  components: {
    Select,
    Modal,
    SuccessNotif,
    WarningTenant,
    CKEditor,
  },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      imageso: "",
      isModalVisible: false,
      promoCategory: [],
      modalpromotion: false,
      promotions: [],
      tenantList: [],
      errors: {
        product_images: false,
        carousel_image: false,
        tenant_id: false,
        category_promotion_id: false,
        promotion_name: false,
        promotion_description: false,
        promotion_start: false,
        promotion_end: false,
        is_active: false,
        product_images_msg: "",
        carousel_image_msg: "",
        tenant_id_msg: "",
        category_promotion_id_msg: "",
        promotion_name_msg: "",
        promotion_description_msg: "",
        promotion_start_msg: "",
        promotion_end_msg: "",
        is_active_msg: "",
      },
      dropDown: {
        isOpen: false,
        inputSearch: true,
        dataSelect: [],
        title: "Nama Tenant",
        selected: "pilih sesuatu",
      },
      categoryDropDown: {
        isOpen: false,
        inputSearch: true,
        dataSelect: [],
        title: "Promo Category",
        selected: "pilih sesuatu",
      },
      table: {
        current_page: 1,
        per_page: 10,
        search: "",
        total: 0,
      },
      avatar: {
        previewFileProduct: [],
        fileProduct: [],
        previewFileCarousel: null,
        fileCarousel: null,
      },
      create: {
        tenant_id: null,
        category_promotion_id: null,
        promotion_name: "",
        promotion_description: "",
        promotion_start: new Date(),
        promotion_end: new Date(),
        is_active: true,
      },
      saveButton: "Save",
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    promotionNameChange: function(e) {
      this.create.promotion_name = e.target.value;
      this.errors.promotion_name = false;
      this.errors.promotion_name_msg = "";
    },
    promotionDescriptionChange: function() {
      // this.create.promotion_description = e.target.value;
      this.errors.promotion_description = false;
      this.errors.promotion_description_msg = "";
    },
    openSelect: function() {
      this.dropDown.isOpen = !this.dropDown.isOpen;
    },
    selectItem: function(val) {
      this.dropDown.isOpen = false;
      this.create.tenant_id = val.id;
      this.dropDown.selected = val.name;
      this.errors.tenant_id = false;
      this.errors.tenant_id_msg = "";
    },
    categoryOpenSelect: function() {
      this.categoryDropDown.isOpen = !this.categoryDropDown.isOpen;
    },
    categorySelectItem: function(val) {
      this.categoryDropDown.isOpen = false;
      this.create.category_promotion_id = val.id;
      this.categoryDropDown.selected = val.name;
      this.errors.category_promotion_id = false;
      this.errors.category_promotion_id_msg = "";
    },
    onSearch: function(val) {
      this.findTenant(val);
    },
    searchSubscriber: function() {
      this.current_page = 1;
      this.per_page = 10;
      this.findPromotions();
    },
    nexPage: function() {
      this.table.current_page = this.table.current_page + 1;
      this.findPromotions();
    },
    previewPage: function() {
      this.table.current_page = this.table.current_page - 1;
      this.findPromotions();
    },
    findpage: function(page) {
      this.table.current_page = page;
      this.findPromotions();
    },
    convertTZ: function(date, tzString) {
      return new Date(
        (typeof date === "string"
          ? new Date(date)
          : date
        ).toLocaleString("en-US", { timeZone: tzString })
      );
    },
    detailContent: function(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    chooseSingleFile: function() {
      document.getElementById("product_file").click();
    },
    removeProductPromotion: function() {
      this.avatar.previewFileProduct = [];
      this.avatar.fileProduct = [];
    },
    chooseFileLocation: function() {
      document.getElementById("carousel_file").click();
    },
    removeCarouselPromotion: function() {
      this.avatar.fileCarousel = null;
      this.avatar.previewFileCarousel = null;
    },
    previewProductPromo: function(event) {
      let input = event.target;
      let count = input.files.length;
      let index = 0;
      if (input.files) {
        while (count--) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.avatar.previewFileProduct.push(e.target.result);
          };
          this.avatar.fileProduct.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
      this.errors.product_images = false;
      this.errors.product_images_msg = "";
    },
    previewCarouselPromo: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewFileCarousel = e.target.result;
        };
        this.avatar.fileCarousel = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.carousel_image = false;
      this.errors.carousel_image_msg = "";
    },
    showModalPromotion: function() {
      this.create = {
        tenant_id: null,
        category_promotion_id: null,
        promotion_name: "",
        promotion_description: "",
        promotion_start: new Date(),
        promotion_end: new Date(),
        is_active: true,
      };
      this.avatar = {
        previewFileProduct: [],
        fileProduct: [],
        previewFileCarousel: null,
        fileCarousel: null,
      };
      this.modalpromotion = !this.modalpromotion;
    },
    findPromotions: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/promotion?current_page=${this.table.current_page}&per_page=${this.table.per_page}&search=${this.table.search}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.promotions = respon.data.promotions;
        this.table.current_page = respon.data.current_page;
        this.table.per_page = respon.data.per_page;
        // this.table.search = respon.data.search
        this.table.total = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findCategoryPromotion: async function() {
      try {
        let res = await fetch(`${API}v1/promotion-categories`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.categoryDropDown.dataSelect = respon.data.map((itm) => {
          return {
            id: itm.id,
            name: itm.promotion_category_name,
          };
        });
      } catch (err) {
        this._error("internal server error");
      }
    },
    createPromo: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("tenant_id", this.create.tenant_id);
      formdata.append(
        "category_promotion_id",
        this.create.category_promotion_id
      );
      formdata.append("promotion_name", this.create.promotion_name);
      formdata.append(
        "promotion_description",
        this.create.promotion_description
      );
      formdata.append("promotion_start", new Date(this.create.promotion_start).toLocaleString());
      formdata.append("promotion_end", new Date(this.create.promotion_end).toLocaleString());
      formdata.append("is_active", this.create.is_active);
      this.avatar.fileProduct.map((product) => {
        formdata.append("product_images", product);
      });
      formdata.append("carousel_image", this.avatar.fileCarousel);
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/store`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "product_images") {
                this.errors.product_images = true;
                this.errors.product_images_msg = item.message;
              }
              if (item.key === "carousel_image") {
                this.errors.carousel_image = true;
                this.errors.carousel_image_msg = item.message;
              }
              if (item.key === "tenant_id") {
                this.errors.tenant_id = true;
                this.errors.tenant_id_msg = item.message;
              }
              if (item.key === "category_promotion_id") {
                this.errors.category_promotion_id = true;
                this.errors.category_promotion_id_msg = item.message;
              }
              if (item.key === "promotion_name") {
                this.errors.promotion_name = true;
                this.errors.promotion_name_msg = item.message;
              }
              if (item.key === "promotion_description") {
                this.errors.promotion_description = true;
                this.errors.promotion_description_msg = item.message;
              }
              if (item.key === "promotion_start") {
                this.errors.promotion_start = true;
                this.errors.promotion_start_msg = item.message;
              }
              if (item.key === "promotion_end") {
                this.errors.promotion_end = true;
                this.errors.promotion_end_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalpromotion = false;
        this.saveButton = "Save";
        this.findPromotions();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalpromotion = false;
        this._error("internal server error");
      }
    },
    findTenant: async function(keword) {
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants?search=${keword}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dropDown.dataSelect = respon.data.tenants;
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findPromotions();
    this.findTenant("");
    this.findCategoryPromotion();
  },
};
</script>
